module.exports = __webpack_public_path__ + "img/CS48Q-中_08.feb413c5.jpg";